// Detect input method in order to hide outlines in an accessible manner
// https://github.com/ten1seven/what-input
import "what-input";


// Modules that do depend on the CSSOM
import "../modules/a11y-menu";
import "../modules/recite-me-toggle";
import "../modules/form-validation";
import "../modules/story-template";
import "../modules/gallery-modal";
import "../modules/share-your-vision-story-upload-form";
import "../modules/share-your-vision-donation-url-generator";
import CtaHero from "../modules/cta-hero";

new CtaHero('[data-controller="cta-hero"]');

import ImageGenerator from "../modules/image-generator";

new ImageGenerator();

// Navigation
import ExpandToggle from "@threespot/expand-toggle";

const burgerEl = document.querySelector('[data-expands="nav"]');

if (burgerEl) {
  let burgerToggle = new ExpandToggle(burgerEl);

  document.documentElement.addEventListener("nav-expanded", () => {
    burgerToggle.updateExpandedHeight();
  });
}

const navItems = document.querySelectorAll('[data-expands="nav-submenu"]');

navItems.forEach((item) => {
  let toggle = new ExpandToggle(item);
  let event = new Event("nav-expanded", { bubbles: true });

  toggle.on("expand", () => {
    item.dispatchEvent(event);
    console.log("expanded");
  });
});
